<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style>
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
/**侧边栏样式修改 */


.el-menu-vertical-demo .el-menu-item-group
{
  background-image: linear-gradient( 135deg, #334157   ,#2424a3    ) !important;
}

.el-menu--popup-right-start{
  background-image: linear-gradient( 135deg, #334157   ,#2424a3    ) !important;
}
.el-menu-item.is-active {

  font-weight: 900!important;
  font-size: 20px!important;

}





</style>



// WEBPACK FOOTER //
// src/App.vue